<div class="grid-container v-pad">
  @if (dataLoading?.value === false) {
    @if (authorizationRequest != null) {
      @if (isCredited) {
        <div class="grid-x user-form-max-width">
          @if (authorizationResponse && !isError) {
            <div class="cell small-12 medium-12">
              <receipt [applicationNumber]="authorizationRequest.applicationNumber"
                [records]="records"
                [authorization]="authorizationResponse"
                [autoGeneratePdf]="true"
                [isPaid]="true"
                [isCredit]="true"
                [disableInvoice]="control.disabled"
                [config]="componentData.config"
                [isSinglePaymentType]="true"
                (receiptIssued)="onReceiptIssued($event)">
              </receipt>
            </div>
          }
          @if (authorizationResponse || isError) {
            <div class="cell small-12 medium-12">
              {{cancellationText}}
            </div>
          }
        </div>
      }
      @if (isLiquidAsset) {
        <div class="grid-x user-form-max-width">
          @if (!(loadingInvoice$ | async)) {
            <div class="cell small-12 medium-12">
              <receipt [applicationNumber]="authorizationRequest.applicationNumber"
                [records]="records"
                [autoGeneratePdf]="true"
                [isPaid]="false"
                [isCredit]="false"
                [disableInvoice]="control.disabled"
                [isSinglePaymentType]="true"
                [config]="componentData.config"
                (receiptIssued)="onReceiptIssued($event)">
              </receipt>
            </div>
          } @else {
            Loading invoice ... please wait ...
          }
        </div>
      }
    } @else {
      No payments are due for this application.
    }
  }
  <text-loader [run]="dataLoading?.value === true" [text]="'Loading'" [interval]="1000" [tickType]="'.'"></text-loader>
</div>

